import Swal from "sweetalert2";
import { wencesApi } from "@/api/wencesApi";

/** El pago quedó marcado como pagado (el backend lo guarda como booleano o como string). */
export function paymentIsPaid(payment) {
  const paid = payment && payment.paid;
  return paid === true || paid === "true" || paid === 1 || paid === "1";
}

/**
 * Quién puede borrar un pago. El endpoint de borrado permanente pide `payment.manage`
 * (o admin), así que el icono se muestra con ese mismo criterio y no con el de finanzas:
 * de otro modo el tacho aparece y el backend devuelve 403.
 *
 * @param {(perm: string) => boolean} hasPermission — el de `permissionsMixin`.
 */
export function canDeletePaymentsFor(hasPermission) {
  if (localStorage.getItem("role") === "admin") return true;
  return typeof hasPermission === "function" && hasPermission("payment.manage");
}

/**
 * Confirmación + borrado permanente del pago, con spinner mientras viaja el request.
 * Un pago ya marcado como pagado se puede borrar igual, pero el aviso lo dice antes.
 *
 * @param {(key: string) => string} t — `this.$t`.
 * @returns {Promise<{deleted: boolean, canceled: boolean, error: string}>}
 */
export async function confirmAndDeletePayment(t, payment) {
  if (!payment || !payment._id) return { deleted: false, canceled: true, error: "" };
  const confirm = await Swal.fire({
    icon: "warning",
    title: t("financialSummary.stages.quickMarkPaymentPaidDeleteConfirmTitle"),
    text: paymentIsPaid(payment)
      ? t("financialSummary.stages.quickMarkPaymentPaidDeleteConfirmPaidText")
      : t("financialSummary.stages.quickMarkPaymentPaidDeleteConfirmText"),
    showCancelButton: true,
    confirmButtonText: t("YesDeleteIt"),
    cancelButtonText: t("cancel"),
    confirmButtonColor: "#dc3545",
  });
  if (!confirm.isConfirmed) return { deleted: false, canceled: true, error: "" };

  Swal.fire({
    title: t("financialSummary.stages.quickMarkPaymentPaidDeleteLoadingTitle"),
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => Swal.showLoading(),
  });
  try {
    await wencesApi.delete(
      `/api/gotrading/dynamic/payment/${encodeURIComponent(String(payment._id))}/permanent`
    );
    await Swal.fire({
      icon: "success",
      title: t("financialSummary.stages.quickMarkPaymentPaidDeleteSuccessTitle"),
      timer: 1800,
      showConfirmButton: false,
    });
    return { deleted: true, canceled: false, error: "" };
  } catch (error) {
    console.error("confirmAndDeletePayment:", error);
    let msg = t("financialSummary.stages.quickMarkPaymentPaidDeleteError");
    if (error.response && error.response.data) {
      msg = error.response.data.message || error.response.data.error || msg;
    }
    await Swal.fire({ icon: "error", title: t("error"), text: msg });
    return { deleted: false, canceled: false, error: msg };
  }
}
